import React from 'react';
import { ThemeId } from '../../data/learning';

// Eigen, geometrische thema-illustraties in het DigitalNext-palet.
// Decoratief (aria-hidden), met subtiel zwevende accenten (.ill-float).
// Bewust geen stockfoto's: dit houdt het geheel consistent en licht.

const GOLD = '#C29A33';
const GOLD_SOFT = '#E9C766';
const HAIR = '#E7E2DB';
const INK = '#17130E';

const Ai: React.FC = () => (
  <>
    <circle cx={92} cy={74} r={54} fill="#EAEEFC" />
    {/* Kompas */}
    <circle cx={92} cy={74} r={36} fill="#fff" stroke={HAIR} strokeWidth={2} />
    <circle cx={92} cy={74} r={28} fill="none" stroke="#EFEAE3" strokeWidth={1.5} />
    {[0, 45, 90, 135, 180, 225, 270, 315].map((a) => {
      const r1 = 30, r2 = 34, rad = (a * Math.PI) / 180;
      return <line key={a} x1={92 + Math.cos(rad) * r1} y1={74 + Math.sin(rad) * r1} x2={92 + Math.cos(rad) * r2} y2={74 + Math.sin(rad) * r2} stroke="#B9AF9E" strokeWidth={1.5} />;
    })}
    <polygon points="92,52 99,74 92,70 85,74" fill="#2440CF" />
    <polygon points="92,96 85,74 92,78 99,74" fill="#C9D2F7" />
    <circle cx={92} cy={74} r={4} fill={INK} />
    {/* Netwerk-nodes */}
    <g className="ill-float">
      <line x1={148} y1={38} x2={170} y2={58} stroke="#C9D2F7" strokeWidth={2} />
      <line x1={170} y1={58} x2={156} y2={82} stroke="#C9D2F7" strokeWidth={2} />
      <circle cx={148} cy={38} r={7} fill="#2440CF" />
      <circle cx={170} cy={58} r={5} fill="#fff" stroke="#2440CF" strokeWidth={2.5} />
      <circle cx={156} cy={82} r={4} fill="#2440CF" />
    </g>
    <circle className="ill-float-b" cx={40} cy={36} r={6} fill={GOLD_SOFT} />
  </>
);

const Dg: React.FC = () => (
  <>
    <circle cx={124} cy={72} r={54} fill="#F6EFD9" />
    {/* Browservenster */}
    <rect x={44} y={36} width={112} height={76} rx={10} fill="#fff" stroke={HAIR} strokeWidth={2} />
    <line x1={44} y1={56} x2={156} y2={56} stroke={HAIR} strokeWidth={2} />
    <circle cx={58} cy={46} r={3.5} fill={GOLD} />
    <circle cx={70} cy={46} r={3.5} fill="#E5D9BC" />
    <circle cx={82} cy={46} r={3.5} fill="#E5D9BC" />
    {/* Map + documentregels */}
    <path d="M58 72 h16 l5 6 h21 a4 4 0 0 1 4 4 v14 a4 4 0 0 1 -4 4 H58 a4 4 0 0 1 -4 -4 V76 a4 4 0 0 1 4 -4 z" fill={GOLD} opacity={0.9} />
    <line x1={116} y1={74} x2={144} y2={74} stroke="#D8CCAF" strokeWidth={3} strokeLinecap="round" />
    <line x1={116} y1={84} x2={138} y2={84} stroke="#EDE4CC" strokeWidth={3} strokeLinecap="round" />
    <line x1={116} y1={94} x2={142} y2={94} stroke="#EDE4CC" strokeWidth={3} strokeLinecap="round" />
    {/* Zwevend bestand */}
    <g className="ill-float">
      <rect x={150} y={20} width={34} height={40} rx={6} fill="#fff" stroke={HAIR} strokeWidth={2} />
      <line x1={158} y1={32} x2={176} y2={32} stroke={GOLD} strokeWidth={3} strokeLinecap="round" />
      <line x1={158} y1={41} x2={172} y2={41} stroke="#EDE4CC" strokeWidth={3} strokeLinecap="round" />
      <line x1={158} y1={50} x2={175} y2={50} stroke="#EDE4CC" strokeWidth={3} strokeLinecap="round" />
    </g>
    <circle className="ill-float-b" cx={34} cy={104} r={6} fill={GOLD_SOFT} />
  </>
);

const Mw: React.FC = () => (
  <>
    <circle cx={96} cy={72} r={54} fill="#F6E7EA" />
    {/* Krant */}
    <rect x={46} y={34} width={100} height={78} rx={8} fill="#fff" stroke={HAIR} strokeWidth={2} />
    <rect x={56} y={44} width={54} height={10} rx={3} fill={INK} opacity={0.85} />
    <rect x={56} y={62} width={80} height={4.5} rx={2} fill="#E3D5D8" />
    <rect x={56} y={72} width={72} height={4.5} rx={2} fill="#E3D5D8" />
    <rect x={56} y={82} width={78} height={4.5} rx={2} fill="#E3D5D8" />
    <rect x={56} y={92} width={50} height={4.5} rx={2} fill="#E3D5D8" />
    {/* Vergrootglas */}
    <g className="ill-float">
      <circle cx={146} cy={66} r={20} fill="#fff" fillOpacity={0.75} stroke="#8A2C3D" strokeWidth={5} />
      <line x1={160} y1={81} x2={174} y2={96} stroke="#8A2C3D" strokeWidth={7} strokeLinecap="round" />
    </g>
    {/* Uitroep-chip */}
    <g className="ill-float-b">
      <circle cx={44} cy={30} r={11} fill="#8A2C3D" />
      <rect x={42.5} y={23} width={3} height={9} rx={1.5} fill="#fff" />
      <circle cx={44} cy={36} r={1.8} fill="#fff" />
    </g>
    <circle cx={172} cy={116} r={5} fill={GOLD_SOFT} />
  </>
);

const Dv: React.FC = () => (
  <>
    <circle cx={100} cy={72} r={54} fill="#EEEAE3" />
    {/* Schild */}
    <path d="M100 26 l38 13 v26 c0 24 -17 38 -38 47 c-21 -9 -38 -23 -38 -47 V39 z" fill="#2E2A25" />
    <path d="M100 34 l30 10 v21 c0 19 -13.5 30.5 -30 38 V34 z" fill="#453F37" />
    {/* Sleutelgat */}
    <circle cx={100} cy={66} r={9} fill="#fff" />
    <rect x={96.5} y={70} width={7} height={16} rx={3.5} fill="#fff" />
    {/* Zwevend vinkje-schildje */}
    <g className="ill-float">
      <circle cx={152} cy={40} r={14} fill="#fff" stroke={HAIR} strokeWidth={2} />
      <path d="M145 40 l5 5 l9 -10" fill="none" stroke="#2B7A4B" strokeWidth={3.5} strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <circle className="ill-float-b" cx={46} cy={104} r={6} fill={GOLD_SOFT} />
    <circle cx={40} cy={44} r={4} fill="#CFC9BF" />
  </>
);

const Sm: React.FC = () => (
  <>
    <circle cx={104} cy={72} r={54} fill="#E1F0F1" />
    {/* Grote spreekwolk */}
    <path d="M54 46 a12 12 0 0 1 12 -12 h56 a12 12 0 0 1 12 12 v28 a12 12 0 0 1 -12 12 H88 l-16 14 v-14 h-6 a12 12 0 0 1 -12 -12 z" fill="#0E7C86" />
    <circle cx={82} cy={60} r={4} fill="#fff" />
    <circle cx={98} cy={60} r={4} fill="#fff" opacity={0.75} />
    <circle cx={114} cy={60} r={4} fill="#fff" opacity={0.5} />
    {/* Antwoord-wolkje */}
    <g className="ill-float">
      <path d="M132 84 a10 10 0 0 1 10 -10 h30 a10 10 0 0 1 10 10 v18 a10 10 0 0 1 -10 10 h-14 l12 12 v-12 h-28 a10 10 0 0 1 -10 -10 z" fill="#fff" stroke={HAIR} strokeWidth={2} />
      <line x1={142} y1={90} x2={172} y2={90} stroke="#9ECBCF" strokeWidth={3} strokeLinecap="round" />
      <line x1={142} y1={98} x2={164} y2={98} stroke="#D2E8EA" strokeWidth={3} strokeLinecap="round" />
    </g>
    {/* Like-dot */}
    <g className="ill-float-b">
      <circle cx={52} cy={104} r={12} fill={GOLD_SOFT} />
      <path d="M52 110 c-5 -3.4 -7.5 -6 -7.5 -9 a4 4 0 0 1 7.5 -2 a4 4 0 0 1 7.5 2 c0 3 -2.5 5.6 -7.5 9 z" fill="#fff" />
    </g>
  </>
);

const SCENES: Record<ThemeId, React.FC> = { ai: Ai, dg: Dg, mw: Mw, dv: Dv, sm: Sm };

export const ThemeIllustration: React.FC<{ themeId: ThemeId; className?: string; style?: React.CSSProperties }> = ({ themeId, className, style }) => {
  const Scene = SCENES[themeId] || Ai;
  return (
    <svg viewBox="0 0 220 140" className={className} style={style} aria-hidden="true" focusable="false">
      <Scene />
    </svg>
  );
};
